import { createAction } from '@reduxjs/toolkit';
import { CfgGeralState } from './cfgGeralTypes';

export const setCfgGeralAction = createAction<CfgGeralState>('CFGGERAL/SET_CFG_LOCAL');
